/* eslint eqeqeq:"off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { toast } from "react-hot-toast";
// import { isEmpty } from "lodash";
import { Col, Row, Skeleton } from "antd";
// import { dashboardHeaders } from "./data";
import "./index.css";
// import { useDispatch } from "react-redux";
// import { useHistory } from "react-router";
// import moment from "moment";
// import {
//   AreaChart,
//   Area,
//   // Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";
import {
  loadDashboardTransactions,
  // loadTotalBalance,
} from "../../store/purchase-orders/actions";
// import { PiUserSoundFill } from "react-icons/pi";
import useMedia from "use-media-antd-query";
import { useDispatch, useSelector } from "react-redux";
import { RiOrganizationChart } from "react-icons/ri";
import { BiDownArrowAlt, BiUpArrowAlt } from "react-icons/bi";

const Dashboard = () => {
  const media = useMedia();
  const dispatch = useDispatch();

  //organisation id from login response
  const notifications = localStorage.getItem("welcomeAdminNotification");
  // const userValues = localStorage.getItem("authData");
  // const userNameDetails = JSON.parse(userValues);

  // const organizationId =
  //   !isEmpty(userNameDetails) && userNameDetails.user.organizations.length > 0
  //     ? userNameDetails.user.organizations[0].organizationId
  //     : "";

  // const transationList = { organizationId: organizationId };

  //Initial state
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    if (notifications === true || notifications === "true") {
      const timer = setTimeout(() => {
        toast.success(`Welcome Back ! `);
        localStorage.setItem("welcomeAdminNotification", "");
        dispatch(loadDashboardTransactions());
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      dispatch(loadDashboardTransactions());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer
  const { dashboard_transactions = [] } = useSelector(
    (state) => state.PurchaseOrders
  );

  const dashboardHeaders = [
    {
      label: "No. of Organizations",
      key: "1",
      icon: <RiOrganizationChart size={22} />,
      count:
        dashboard_transactions &&
        dashboard_transactions !== undefined &&
        dashboard_transactions.total !== undefined
          ? dashboard_transactions.total
          : 0,
      color: "",
    },
    {
      label: "New Organizations Today",
      key: "2",
      icon: <RiOrganizationChart size={22} />,
      count:
        dashboard_transactions &&
        dashboard_transactions !== undefined &&
        dashboard_transactions.today !== undefined
          ? dashboard_transactions.today
          : 0,
      color: "",
    },
    {
      label: "Active Organizations",
      key: "3",
      icon: <BiUpArrowAlt size={22} />,
      count:
        dashboard_transactions &&
        dashboard_transactions !== undefined &&
        dashboard_transactions.active !== undefined
          ? dashboard_transactions.active
          : 0,
      color: "green",
    },
    {
      label: "Inactive Organizations",
      key: "4",
      icon: <BiDownArrowAlt size={22} />,
      count:
        dashboard_transactions &&
        dashboard_transactions !== undefined &&
        dashboard_transactions.inactive !== undefined
          ? dashboard_transactions.inactive
          : 0,
      color: "red",
    },
  ];
  //Date values
  // const todayDate = moment().format("DD MMM YYYY");
  // const beforeWeek = moment().subtract(1, "week").format("DD MMM YYYY");

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //number format
  // var inrFormat = new Intl.NumberFormat()

  return (
    <React.Fragment>
      {/* <Layout> */}
      <div className="pl-5">
        <MetaTags>
          <title>Dashboard | Mbook</title>
        </MetaTags>
      </div>
      {/* <Row className="bg-[#ffffff]"> */}
      <Row className="bg-[#ffffff]">
        <Col span={24} className="border pb-2 border-b-1 border-x-0 border-t-0">
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] ml-2 mt-1 font-semibold"
              >
                Dashboard
              </h1>
            </div>
            {/* <div className="flex">
              <div className="flex text-[12px] border bg-[#ffffff] text-[#000000] rounded-md ml-3 pl-6 pr-6 p-1 cursor-pointer">
                <PiUserSoundFill className="mt-1 mr-2" /> Share Suggestion
              </div>
            </div> */}
          </div>
        </Col>
      </Row>
      <Row
        className={
          windowDimensions.height >= 700 && windowDimensions.height <= 767
            ? "dashboard-main-card-medium-device bg-[#ffffff]"
            : windowDimensions.height > 767 && windowDimensions.height < 830
            ? "dashboard-main-card-large-device bg-[#ffffff]"
            : windowDimensions.height > 830 && windowDimensions.height < 900
            ? "dashboard-main-card-extra-large-device bg-[#ffffff]"
            : windowDimensions.height > 900 && windowDimensions.height < 960
            ? "dashboard-main-card-extra-extra-large-device bg-[#ffffff]"
            : windowDimensions.height >= 960 && windowDimensions.height < 1000
            ? "dashboard-main-card-extra-infinite-large-device bg-[#ffffff]"
            : windowDimensions.height >= 1000
            ? "dashboard-main-card-extra-infinite-large-device bg-[#ffffff]"
            : "bg-[#ffffff] dashboard-main-card"
        }
      >
        <Col md={24} xl={24} xxl={24} lg={24} sm={24} xs={24} className="pb-2">
          <Row className="pl-5 mt-5 mb-5">
            {dashboardHeaders.map((data) => {
              return (
                <Col
                  md={12}
                  xl={6}
                  xxl={6}
                  lg={6}
                  sm={24}
                  xs={24}
                  key={data.key}
                  className={
                    media == "sm" || media == "xs"
                      ? "mt-4"
                      : media == "md" && (data.key == "3" || data.key == "4")
                      ? "mt-4"
                      : ""
                  }
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        marginRight: "5px",
                        minWidth:
                          media === "xxl"
                            ? "185%"
                            : media == "sm" || media == "xs"
                            ? "255%"
                            : "125%",
                        height: "100px",
                      }}
                      active={true}
                      size={"large"}
                    ></Skeleton.Input>
                  ) : (
                    <div
                      className={
                        // purchaseTab === data.label
                        // ? "poppins flex mr-4 parties-select-card parties-card border rounded-md"
                        // :
                        "poppins mr-4 dashboard-card border rounded-md shadow-sm"
                        // "poppins flex justify-between mr-4 dashboard-card border rounded-md shadow-sm"
                      }
                      // onClick={() => {
                      //   // setPurchaseTab(data.label);
                      //   setLoading(true);
                      //   setTimeout(() => {
                      //     setLoading(false);
                      //   }, 2000);
                      // }}
                    >
                      <div
                        style={{
                          fontSize: "14px",
                          display: "flex",
                          color: data.color,
                          fontFamily: "Poppins",
                        }}
                      >
                        <p
                          className={
                            data.key !== 1
                              ? "text-[20px] font-semibold"
                              : "font-semibold"
                          }
                        >
                          {data.icon}
                        </p>
                        <h2 className={"ml-2"}>{data.label}</h2>
                      </div>
                      <div
                        className={data.key !== "2" ? "mt-4 ml-3" : "mt-4 ml-3"}
                      >
                        <h1 className="font-semibold font-label text-[20px]">
                          {data.count}
                        </h1>
                      </div>
                    </div>
                  )}
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      /> */}
    </React.Fragment>
  );
};

export default Dashboard;
